<template >
  <b-card>
    <b-row>
      <b-table
          :items="listConfeccion"
          :fields="columnasTableSku"
          class="table table-borderless table-fabricacion"
          outlined
          striped
          responsive
          ref="tableDetalles"
          >

          <template #cell(_titulo)="data">
            <p>{{ data.item.color }} ({{ data.item.cantidad }})</p>
          </template>

          <template #cell(_letras)="data">
            <div style="text-align: center;" v-if="data.item.letras.length > 2">
              <span @click="scrollLeftLetras(data.index)" class="scroll-button-table left-button"><i class="fa-solid fa-circle-arrow-left"></i></span>
              <span @click="scrollRightLetras(data.index)" class="scroll-button-table right-button"><i class="fa-solid fa-circle-arrow-right"></i></span>
            </div>
          
            <div class="scroll-container" :ref="'scrollContainer_' + data.index">
                <div class="scroll-content">
                    <span v-for="letra, index in data.item.letras" :key="index" class="letra-container" style="margin-right: 5px">
                        <div :class="{'div-imagenes': letra.finalizado, 'div-proceso': letra.iniciado}" style="padding: 5px">
                            <b style="margin-right: 5px;">{{ letra.letra }}</b>
                            <img :src="letra.img" alt="" style="max-width: 100%;">
                        </div>
                    </span>
                </div>
            </div>
          </template>

      </b-table>
    </b-row>
  </b-card>
</template>

<script>
  import axios from '@axios'
  /*import VueApexCharts from 'vue-apexcharts'*/
  import { BTable, BFormInput, BFormGroup, BRow, BCol } from 'bootstrap-vue'
  import BCardCode from '@core/components/b-card-code'
  import vSelect from 'vue-select'
  import { mapGetters } from 'vuex';
  import { forEach } from 'postcss-rtl/lib/affected-props'

  export default {
    components: {
        BCardCode,
        BTable,
        BFormInput,
        BFormGroup,
        BRow,
        BCol,
        vSelect,
    },
    data () {
      return {
        columnasTable: [
        {
          key: "mano1",
          label: "Mano",
          sortable: true,
        },{
          key: "mano2",
          label: "Mano",
          sortable: true,
        },{
          key: "aparado1",
          label: "Aparado",
          sortable: true,
        },{
          key: "aparado2",
          label: "Aparado",
          sortable: true,
        },{
          key: "img",
          label: "Terminado",
          sortable: true,
        },{
          key: "options",
          label: "Reportes",
          thStyle: { width: "5%" },
        }],
        columnasTableSku: [{
          key: "titulo",
          label: "Modelo",
          sortable: true,
        },{
          key: "_titulo",
          label: "Color",
          sortable: true,
        },{
          key: "_letras",
          label: "Letras",
          sortable: false,
        }],
        tareas: [],
        allTareas: [],
        coloresSku: [],
        colorSelect: null,
        listSku: [],
        skuSelect: null,
        skuConfeccion: [],
        tituloSelect: "",
        tareaReport: {nombreCategoria: ""},
        descripcionReport: "",
        reportTipo: 0,
        cantidadObjetivo: 0,
        cantidadCortada: 0,
        timer: "",
        countDown: 30,
        allLetras: [],
        letras: [],
        gruposImagenes: [],
        listCategoria: [],
        allCategorias: [],
        letraSeleccionada: [],
        maxWidth: "130px",
        maxHeight: "130px",
        listConfeccion: []
      }
    },
    methods:{
      async loadItems(autoload = false){
        //try {

          axios.post("/uso", {seccion:"fabricacionMaster"});

            const responseCategoria = await axios.get("/confeccion/categorias");
            const resCategorias = responseCategoria.data;

            this.allCategorias = resCategorias;

            /*Obtengo los sku de gestionar dia*/
            const responseConfeccionDia = await axios.get("/taller/master/confeccion/dia");
            const resConfeccionDia = responseConfeccionDia.data;
            
            const sku = resConfeccionDia.map(element => this.eliminarUltimoApartado(element.sku))
            this.skuConfeccion = resConfeccionDia;

            const responsePieza = await axios.post("/confeccion/tarea/list", {list: [...new Set(sku)] });
            const resPieza = responsePieza.data;

            this.allTareas = resPieza;
        
            const ids = resPieza.map(element => element.idLetra)

            const responseLetras = await axios.post("/confeccion/letra/id", {list: [...new Set(ids)] });
            const resLetras = responseLetras.data;

            this.allLetras = resLetras;

            this.allLetras.sort((a, b) => Number(a.orden) - Number(b.orden));

            /*Obtengo el estado de las piezas de ese pedido*/
            const skuPedido = this.skuConfeccion.flatMap(dato => {
              return this.allTareas
                .filter(tarea => tarea.sku === this.eliminarUltimoApartado(dato.sku))
                .map(tarea => ({ idPedido: dato.idPedido, idTarea: tarea.id, color: dato.sku.split('-').pop() }));
            });

            const responseTareaEstado = await axios.post("/taller/pieza/pedido/confeccion", {info: skuPedido });
            const resTareaEstado = responseTareaEstado.data;

            this.allTareas = resTareaEstado.map(tarea => {
              const finalizado = tarea.terminado > 0;
              return { ...tarea, finalizado };
            });

            this.allTareas.forEach((obj2) => {
              const obj1 = resPieza.find((obj1) => obj1.id === obj2.id);
              if (obj1) {
                obj2.sku = obj1.sku;
              }
            });

            this.allTareas.sort((a, b) => Number(a.orden) - Number(b.orden));

            this.allTareas.forEach(tarea => {
                const matchingCategoria = resCategorias.find(cat => tarea.idCategoria === cat.id && cat.id !== 0);
                if (matchingCategoria) {
                    tarea.nombreCategoria = matchingCategoria.nombre;
                }
            });

            //Quito el color del articulo y quito los duplicados (para mostrar arriba, el color ira dentro de cada uno)
            const articuloSinDuplicar = [];

            this.skuConfeccion.forEach(articulo => {
              const skuSinUltimoApartado = this.eliminarUltimoApartado(articulo.sku);
              const colorArticulo = this.obtenerUltimoApartado(articulo.sku);
              //const skuSinUltimoApartado = articulo.sku;
              
              if (!articuloSinDuplicar.some(objeto => objeto.sku === skuSinUltimoApartado && colorArticulo === objeto.color && objeto.idPedido == articulo.idPedido)) {
                const articuloSinDuplicado = { ...articulo, color: colorArticulo, sku: skuSinUltimoApartado };
                articuloSinDuplicar.push(articuloSinDuplicado);
              }
            });

            this.listSku = articuloSinDuplicar.map(element => ({ sku: element.sku, color: element.color, titulo: element.titulo, variant: "outline-dark", idPedido: element.idPedido }));
            this.skuSelect = this.listSku[0].sku;
            this.tituloSelect = this.listSku[0].titulo;

            this.listSku.forEach(item => {
              item.cantidad = this.skuConfeccion.reduce((total, articulo) => {
                if (this.eliminarUltimoApartado(articulo.sku) == item.sku && articulo.sku.includes(item.color) && item.idPedido == articulo.idPedido) {
                  return total + articulo.cantidad;
                }
                return total;
              }, 0);
            });

            //Opcion con los colores separados
            this.listSku.forEach(skuItem => {
                skuItem.letras = this.allLetras.filter(letraItem => letraItem.sku === skuItem.sku).map(letraItem => {
                  return JSON.parse(JSON.stringify(letraItem));
                });
            });

            /*this.listSku.forEach(skuItem => {
              skuItem.letras.forEach(letra => {
                letra.tareas = [];
                this.allTareas.forEach(tarea => {

                  if(tarea.idLetra == letra.id && tarea.color == skuItem.color)
                  {
                    if(skuItem.sku == "TECH-DOPP-KIT")
                      console.log(skuItem.color + ' | ' + tarea.color);

                    letra.tareas.push(tarea);
                  }
                    

                });
              });
            });*/

            this.listSku.forEach(skuItem => {
                skuItem.letras.forEach(letra => {
                    letra.tareas = this.allTareas.filter(tarea => tarea.idLetra === letra.id && tarea.color === skuItem.color && tarea.idPedido == skuItem.idPedido);
                });
            });

            
            //console.log(this.listSku);

            // Creamos un nuevo objeto para agrupar por color
            this.listConfeccion = [];

            this.listSku.forEach(skuItem => {
              //if(skuItem.sku == "TECH-DOPP-KIT" && skuItem.color == "TAN")
                this.listConfeccion.push(skuItem);
            });

            this.listConfeccion.forEach(sku => { 
                sku.letras.forEach(letra => {
                    letra.finalizado = letra.tareas.every(tarea => tarea.finalizado);
                    letra.iniciado = letra.tareas.some(tarea => tarea.finalizado || tarea.iniciado);
                });
            });


            this.listConfeccion.sort((a, b) => (a.sku > b.sku) ? 1 : -1);

            /*this.listConfeccion.forEach(sku => { 
                if(sku.sku == "TECH-DOPP-KIT" && sku.color == "TAN")
                {
                  console.log(sku);
                }
            });*/
            

            /*this.listSku.forEach(skuItem => {
                skuItem.letras.forEach(letraItem => {
                    letraItem.listaTarea.forEach(tareaItem => {
                        const { color } = tareaItem;
                        let existingEntry = this.listConfeccion.find(entry => entry.sku === skuItem.sku && entry.color === color);
                        if (!existingEntry) {
                          this.listConfeccion.push({
                                sku: skuItem.sku,
                                titulo: skuItem.titulo,
                                color: color,
                                variant: skuItem.variant,
                                cantidad: skuItem.cantidad,
                                letras: []
                            });
                            existingEntry = this.listConfeccion.find(entry => entry.sku === skuItem.sku && entry.color === color);
                        }
                        let existingLetra = existingEntry.letras.find(letra => letra.id === letraItem.id);
                        if (!existingLetra) {
                            existingEntry.letras.push({
                                id: letraItem.id,
                                letra: letraItem.letra,
                                orden: letraItem.orden,
                                img: letraItem.img,
                                ancho: letraItem.ancho,
                                titulo: letraItem.titulo,
                                sku: letraItem.sku,
                                finalizado: false,
                                iniciado: false,
                                tareas: []
                            });
                            existingLetra = existingEntry.letras.find(letra => letra.id === letraItem.id);
                        }
                        existingLetra.tareas.push(tareaItem);


                    });
                });
            });

            this.listConfeccion.forEach(sku => { 
                sku.letras.forEach(letra => {
                    letra.finalizado = letra.tareas.every(tarea => tarea.finalizado);
                    letra.iniciado = letra.tareas.some(tarea => tarea.finalizado);
                });
            });

            */
      },
      eliminarUltimoApartado(cadena) {
            const lastIndex = cadena.lastIndexOf("-");
            if (lastIndex !== -1) {
                return cadena.substring(0, lastIndex);
            }
            return cadena;
      },
      obtenerUltimoApartado(cadena) {
        let color = cadena.split('-')[cadena.split('-').length-1];
        return color;
      },
      scrollLeftLetras(index) {
        const container = this.$refs['scrollContainer_' + index];
        container.scrollLeft -= 300; // Ajusta según tu preferencia
      },
      scrollRightLetras(index) {
        const container = this.$refs['scrollContainer_' + index];
        container.scrollLeft += 300; // Ajusta según tu preferencia
      }
    },
    mounted() {
      this.loadItems();
    },
     watch: {  
      confeccionUpdate(newValue, oldValue){
        this.loadItems(true);
      },      

    },
    computed: {
      ...mapGetters('app', ['confeccionUpdate','forceUpdateUser']),
    },
  }
</script>

<style lang="scss">
  @import '../@core/scss/vue/libs/vue-select.scss';

  .btn-circle{
    border-radius: 20px;
    padding: 12px;
    margin-right: 10px;
  }

  .btn-options{
    margin-left: 10px;
    margin-bottom: 10px;
  }

  

  .option-select{
    /*border: 2px solid #000000 !important;*/
    font-weight: bold; 
    font-size: 16px;
    /*box-shadow: 1px 1px 1px 2px rgba(255,255,255,1);*/
    //border: 2px solid #ffffff81 !important;
    box-shadow: 0px 1px 11px 2px rgba(142, 142, 142, 0.75) !important;
    -webkit-box-shadow: 0px 1px 11px 2px rgba(142, 142, 142, 0.75) !important;
    -moz-box-shadow: 0px 1px 11px 2px rgba(142, 142, 142, 0.75) !important;
    //border-style: dotted !important;
  }

  .div-reporte{
    text-align: center;
    padding: 20px; 
    border-radius: 5px;
    border: 1px solid black;
  }

  .dark-layout .div-reporte{
    border: 1px solid white;
  } 

  .spinDisable button{
    display: none;
  }

  .div-imagenes-incompleta{
    background-color: rgba(255, 187, 78, 0.48);
  }

  .div-bloqueado{
    background-color: rgba(147, 147, 147, 0.48) !important;
    border-radius: 15px;
  }

  .div-proceso{
    background-color: rgba(255, 187, 78, 0.48);
    border-radius: 15px;
  }

  table th{
    text-align: center
  }

  .columnSeparador{
    border-right: 5px solid #eeeeee !important;
  }

  .divTrabajo{
    position: relative; display: flex; justify-content: center; align-items: center; 
    padding: 1px;
    margin: 1px;
    padding-top: 5px;
    padding-bottom: 5px;
    margin-top: 5px;
    margin-bottom: 5px;
  }

  .divLetra:hover{
    cursor: pointer;
  }

    .margin-avatar{
    margin-left: 5px
    //margin-right: -15px;
  }

  .margin-avatar-multiple{
    margin-left: -15px;
    //margin-right: -15px;
  }

  .table-fabricacion tr td:nth-child(3) {
        padding: 0px !important;
    }

    .div-imagenes{
        background-color: rgba(124, 255, 130, 0.35) !important;
        border-radius: 15px;
    }

    .scroll-container {
    overflow-x: auto;
    white-space: nowrap;
    margin-bottom: 10px; /* Agregar margen inferior opcional */
}

.scroll-content {
    display: inline-block;
}

.letra-container {
    display: inline-block;
}

.scroll-button-table{
  font-size: 30px;
  padding: 0px;
  padding-left: 5px;
  padding-right: 5px;
}

.scroll-button-table:hover{
  cursor: pointer;
}

</style>